module.exports = __webpack_public_path__ + "assets/img/Type E (28).cbdc11c8.jpg";